export default class FeeRuleHistory {
  rule: string;

  enabled: boolean;

  value: string;

  constructor(obj: any = {}) {
    this.rule = obj.rule || '';
    this.enabled = obj.enabled || '';
    this.value = obj.value || '';
  }

  public static of(obj: any = {}): FeeRuleHistory {
    return new FeeRuleHistory(obj);
  }

  public static ofList(obj: any[]): FeeRuleHistory[] {
    return obj.map(this.of)
  }

  get enabledText() {
    return this.enabled ? 'Sim' : 'Não'
  }
}
